import { styled } from '@fluentui/react';
import { FormSectionBase } from './FormSection.base';
import { getStyles } from './FormSection.styles';
import { IFormSectionProps, IFormSectionStyleProps, IFormSectionStyles } from './FormSection.types';

// Use Fabric Base guidelines since this might be contributed back to Fabric.
export const FormSection = styled<IFormSectionProps, IFormSectionStyleProps, IFormSectionStyles>(FormSectionBase, getStyles, undefined, {
  scope: 'FormSection',
});
